import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IReportTemplate } from '@shared/interfaces';

@Component({
    selector: 'app-template-item',
    templateUrl: './template-item.component.html',
    styleUrls: ['./template-item.component.scss'],
    standalone: false
})
export class TemplateItemComponent {
    @Input() item: IReportTemplate;
    @Input() active: boolean;
    @Input() readonly: boolean;
    @Input() disabled: boolean;
    @Input() editable: boolean;
    @Input() deletable: boolean;
    @Input() hoverable = true;
    @Output() clear = new EventEmitter();
    @Output() preview = new EventEmitter<IReportTemplate>();
    @Output() edit = new EventEmitter<IReportTemplate>();
}
